import styled from 'styled-components'

export default (styled.form || styled.View)`
  background-color: #fff;
`
